import React                  from 'react';
import ReactDOM               from 'react-dom';
import {BrowserRouter}        from 'react-router-dom';
import './index.css';
import App                    from './App';
import registerServiceWorker  from './registerServiceWorker';
import store                  from './store/store';
import '../node_modules/semantic-ui-offline/semantic.min.css';

const renderApp = () => {
  ReactDOM.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
    document.getElementById('root')
  );
};

store.subscribe(renderApp);

registerServiceWorker();

renderApp();



// WEBPACK FOOTER //
// ./src/index.js